import React from "react";
import Breadcrumb from "../../Component/Breadcrumb";
import { Helmet } from "react-helmet";
import { useAuth } from "../../Store/AuthContext";
import { NriCornerData } from "../../APIS/FetchAPIs";

export default function NriCorner() {
  const { RendomTokenfetch } = useAuth();
  const [NriData] = NriCornerData(RendomTokenfetch);
  return (
    <>
      <Helmet>
        <title>{NriData.meta_title}</title>
        <meta name="description" content={NriData.meta_description} />
        <meta name="keywords" content={NriData.meta_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Nri Corner" mainpage="" />
      <section className="service-details-section section-padding">
        <div className="container">
          <div className="service-details-wrapper">
            <div className="row g-4">
              <div className="col-lg-1"></div>
              <div className="col-lg-10">
                <div className="gt-details-thumb">
                  {NriData.about_image !== "" ? (
                    <img
                      src={NriData.about_image}
                      alt={NriData.aboutimg_alt}
                      title={NriData.aboutimg_title}
                    />
                  ) : (
                    <img src="../assets/img/NRI1.jpg" alt="" />
                  )}
                </div>
                <div className="gt-details-content">
                  <div className="gt-details-content">
                    <div className="gt-list-content mb-0">
                      <h3 className="mb-2">{NriData?.title || ""}</h3>
                      {/* <p className="mb-2">{NriData?.about_tagline || ""}</p> */}
                    </div>
                  </div>
                  <div
                    className="gt-list-content mb-0"
                    dangerouslySetInnerHTML={{
                      __html: NriData.about_description,
                    }}
                  ></div>
                </div>
                {/* <div className="gt-details-content">
                  <div className="gt-list-content mb-0">
                    <h3 className="mb-2">
                      NRI Corner – Invest in India, Build Your Legacy, Stay
                      Rooted
                    </h3>
                    <p className="mb-2">
                      India is more than a destination—it’s a connection to
                      culture, family, and identity. For every Non-Resident
                      Indian (NRI), it represents a timeless bond. At Bhadorva
                      Infra, we’ve created the NRI Corner to help you bridge the
                      gap between your global lifestyle and your Indian
                      heritage. Whether you’re investing foremotional
                      fulfillment or strategic growth, we ensure your journey is
                      smooth, secure, and rewarding.
                      <br />
                      We understand that for NRIs, real estate investment in
                      India is not just about returns—it’s about coming home.
                      Whether you’re envisioning a luxurious bungalow, a
                      peaceful farm plot, or a high-potential redevelopment
                      project, Bhadorva Infra offers curated opportunities that
                      blend sentiment with smart investment.
                    </p>
                  </div>
                  <div className="gt-list-content mb-0">
                    <h3>Why NRIs Choose Bhadorva Infra</h3>
                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Sentiment Meets Strategy :</strong>
                          Investing in Indian property is a deeply personal
                          decision. We help you turn that emotion into a
                          strategic asset—combining legacy-building with
                          long-term financial growth.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Comprehensive Real Estate Solutions :</strong>
                          From elegant bungalows and nature-rich farm plots to
                          premium residential plots, custom construction, and
                          redevelopment ventures— Bhadorva Infra is your trusted
                          one-stop partner.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Locations with Momentum :</strong>
                          Our developments are located in regions experiencing
                          rapid infrastructure growth, urban expansion, and
                          rising demand—ensuring your investment grows with
                          India’s progress.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Trust, Transparency & Compliance :</strong>
                          All Bhadorva projects are MahaRERA-registered. We
                          uphold rigorous due diligence, clear documentation,
                          and transparent timelines to protect your interests.
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3>Tailored NRI Services :</h3>

                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Dedicated relationship manager</strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Power of Attorney (PoA) facilitation</strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Legal and tax advisory</strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Remote documentation and tracking</strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>
                            Coordination with banks and legal professionals
                          </strong>
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3>NRI Investment Guidelines: What You Can & Can't Do</h3>
                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Can NRIs buy property in India? :</strong>
                          Yes. NRIs, PIOs, and OCIs can purchase residential and
                          commercial properties without special RBI approval.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>
                            Can they buy agricultural land or farmhouses? :
                          </strong>
                          No. These require specific government permissions.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Is RBI permission needed? :</strong>
                          Not for most purchases, but formalities like Form
                          IPI-7 may apply.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Can sale proceeds be repatriated? :</strong>
                          Yes, subject to RBI rules—especially for properties
                          bought with foreign exchange.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Are taxes applicable? :</strong>
                          Yes. Rental income and capital gains are taxable in
                          India. DTAA may offer relief.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Can NRIs get home loans? :</strong>
                          Yes. Indian banks and housing finance institutions
                          offer loans secured against the property.
                        </span>
                      </li>
                    </ul>
                  </div>


                  <div className="gt-list-content mb-0">
                    <h3>Who Can Invest?</h3>
                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          NRIs, Persons of Indian Origin (PIOs), and Overseas
                          Citizens of India (OCIs) can freely invest in
                          residential and commercial properties.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          Agricultural land, plantations, and farmhouses require
                          special approval from RBI.
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3> What We Offer</h3>

                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Luxury Bungalows :</strong>
                          Architect-designed homes with premium finishes and
                          spacious layouts.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Farm Plots:</strong>
                          Nature-rich retreats ideal for leisure or long-term
                          investment.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Premium Plots:</strong>
                          Ready-to-build plots in gated communities with modern
                          infrastructure.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Construction & Redevelopment :</strong>
                          End-to-end solutions for building or upgrading
                          properties with sustainable design and smart
                          engineering.
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3> Financing & Repatriation Made Simple</h3>
                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>
                            {" "}
                            Partnerships with leading banks for NRI home loans
                          </strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>
                            Rental income and sale proceeds repatriated under
                            RBI guidelines
                          </strong>
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3>Hassle-Free Documentation</h3>
                    <p>
                      <strong>Our NRI Desk supports</strong>
                    </p>
                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> PAN card and KYC formalities</strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>
                            {" "}
                            Property registration and legal checks
                          </strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Taxation and DTAA benefits</strong>
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Power of Attorney setup</strong>
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3> Key Benefits of Investing with Bhadorva Infra</h3>

                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Capital Appreciation :</strong>
                          Invest in high-growth zones with strong long-term
                          value.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Rental Income :</strong>
                          Generate passive income from unused properties.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Diversification :</strong>
                          Hedge against global market volatility and currency
                          shifts.
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Legacy Building :</strong>
                          Create enduring assets for future generations.
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3> Our Streamlined NRI Investment Process</h3>

                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Consultation :</strong>
                          Understand your goals, budget, and preferences
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Project Selection :</strong>
                          Present curated options with insights on returns and
                          legal status
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Legal & Compliance :</strong>
                          Handle title checks, approvals, and RERA documentation
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Funding & Payments :</strong>
                          Use NRE/FCNR accounts or inward remittances
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Remote Execution:</strong>
                          Appoint PoA for local documentation
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Development & Updates :</strong>
                          Receive progress reports, virtual tours, and
                          dashboards
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Monetization & Exit :</strong>
                          Assistance with leasing, resale, and repatriation
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div className="gt-list-content mb-0">
                    <h3>FAQs for NRIs : </h3>
                    <ul>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Documents Required :</strong>
                          Passport, PAN, overseas address proof, NRE/NRO account
                          details, PoA (if applicable)
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Property Limits :</strong>
                          No restriction on the number of residential or
                          commercial properties
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong>Foreign Nationals :</strong>
                          Non-Indians face restrictions and may require RBI
                          approval
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Repatriation Timeline :</strong>
                          Apply within 90 days of sale; limited to two
                          properties bought with foreign exchange
                        </span>
                      </li>
                      <li>
                        <i className="flaticon-right-arrow"></i>
                        <span>
                          <strong> Remote Safety :</strong>
                          Yes—our secure processes, virtual walkthroughs, and
                          legal support ensure peace of mind
                        </span>
                      </li>
                    </ul>
                  </div>


                  <div className="gt-list-content mb-0">
                    <h3>Ready to Invest from Anywhere?</h3>
                    <p className="mb-2">
                      Whether you’re in Toronto, Dubai, London, or
                      Sydney—Bhadorva Infra is your trusted partner in building
                      a future that’s rooted in India and designed for global
                      success.
                    </p>
                  </div>
                </div> */}
              </div>
              <div className="col-lg-1"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
